import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { memo, useEffect, useRef } from "react";
import { useIntl } from "react-intl";
import { usePageState } from "../PageContext";
import * as layouts from "./layouts";
import * as steppers from "./steppers";
import { StepperAnnouncement, stepperMessages } from "./steppers/StepperAnnouncement";
export const FormPages = memo(({ pages, header, modalClick, modalCloseMode, stepper, formIsDisabled, scrollToTop = true }) => {
    const intl = useIntl();
    const { step } = usePageState();
    const { layout, ...page } = pages[step];
    // Moves keyboard + SR virtual-cursor focus to the top of the new page on
    // navigation. Without this, NVDA's browse-mode cursor stays wherever it
    // was on the previous page (typically the Next button at the bottom) —
    // the scroll jumps but the SR reader does not follow.
    const topDivRef = useRef(null);
    useEffect(() => {
        if (!scrollToTop) {
            return;
        }
        if (topDivRef.current) {
            topDivRef.current.scrollIntoView();
            topDivRef.current.focus({ preventScroll: true });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [window.location.href, scrollToTop]);
    const PageComponent = layout && layouts[layout] ? layouts[layout] : layouts.Wizard;
    const StepperComponent = steppers && stepper && steppers[stepper];
    return (_jsxs(_Fragment, { children: [_jsx("div", { id: "scrollToTopDiv", ref: topDivRef, tabIndex: -1 }), StepperComponent && (_jsxs("nav", { "aria-label": intl.formatMessage(stepperMessages.formStepsNav), children: [_jsx(StepperAnnouncement, {}), _jsx(StepperComponent, {})] })), _jsx(PageComponent, { header: header, ...page, modalClick: modalClick, modalCloseMode: modalCloseMode, stepper: stepper, formIsDisabled: formIsDisabled })] }));
});
//# sourceMappingURL=FormPages.js.map